var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/menu-toggle.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.deviceCharacteristics.is_smallish",runtime.contextOrFrameLookup(context, frame, "False")])) || (lineno = 0, colno = 87, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.deviceCharacteristics.is_medium",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("isSmallishOrMedium", t_1, true);
if(frame.topLevel) {
context.setVariable("isSmallishOrMedium", t_1);
}
if(frame.topLevel) {
context.addExport("isSmallishOrMedium", t_1);
}
output += "\n\n<a \n    href=\"#u-navigation-anchor\" \n    rel=\"nofollow\" \n    class=\"c-site-menu-toggle js-site-menu-toggle\" \n    aria-label=\"";
output += runtime.suppressValue((lineno = 6, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["menu-toggle-aria"])), env.opts.autoescape);
output += "\" \n    ";
if(runtime.contextOrFrameLookup(context, frame, "isSmallishOrMedium")) {
output += " aria-controls=\"u-navigation-anchor\" ";
;
}
output += " \n    aria-expanded=\"false\"\n    data-qa-nav-menu-button\n>\n\n    <span class=\"c-site-menu-toggle__inner\">\n\n        <span class=\"c-site-menu-toggle__line\"></span>\n\n    </span>\n\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/menu-toggle.j2"] , dependencies)